import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '@infraestructure/drive-adapter/auth/auth.service';
import { getStoredMemberToken } from './member-token.storage';

export const MEMBER_TOKEN_HEADER = 'X-Member-Token';
/** API response code for a missing, invalid or expired member token. */
export const MEMBER_TOKEN_REJECTED = 161;

// Adds the member token only to Credit Score calls; no other endpoint receives it. A token the API
// rejects (expired or revoked) signs the member out, so they log in again and get a fresh one
// instead of Credit Score silently falling back to the old page.
export const memberTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/creditscore/')) return next(req);

  const token = getStoredMemberToken();
  if (!token) return next(req);

  // Resolved lazily: AuthService itself depends on HttpClient.
  const injector = inject(Injector);
  return next(req.clone({ setHeaders: { [MEMBER_TOKEN_HEADER]: token } })).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && error.error?.responseCode === MEMBER_TOKEN_REJECTED) {
        injector.get(AuthService).logout();
      }
      return throwError(() => error);
    }),
  );
};
